import { Component, JSX } from 'solid-js';

interface TreeProps {
  children: JSX.Element;
}

export const Tree: Component<TreeProps> = (props: TreeProps): JSX.Element => {
  return <>{props.children}</>;
};

export default Tree;
